import React from 'react';
import { List } from 'semantic-ui-react';

const AnchorNavigation = ({ headings }) => {
  const [isClient, setIsClient] = React.useState(null);
  React.useEffect(() => setIsClient(true), []);

  if (headings === undefined && isClient) {
    headings = document.querySelectorAll('#page-document h2');
  }

  const handleClick = (e, id) => {
    e.preventDefault();
    const heading = document.getElementById(id);
    heading?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <List className={'anchor-navigation'}>
      {headings ? (
        Array.from(headings).map((heading) => (
          <List.Item
            key={heading.id}
            href={'#' + heading.id}
            onClick={(e) => handleClick(e, heading.id)}
          >
            {heading.innerText}
          </List.Item>
        ))
      ) : (
        <></>
      )}
    </List>
  );
};

export default AnchorNavigation;
